import { FunctionalComponent, h } from '@stencil/core';
import get from 'lodash/get'
import {SectionHeroProduct, SectionProductGallery} from './'

interface SectionProduct {
    data?: any;
}


export const SectionProduct: FunctionalComponent<SectionProduct> = ({ data }) => {

    if (!data) return;

    const attributes = get(data, 'data.attributes')
    const { Overview, Specification, Hero, Slug } = attributes;
    if (Specification) Specification.Product = get(data, 'data.id');
    if (Hero) Hero.Slug = Slug;

    return [
        Hero && <SectionHeroProduct data={Hero} />,
        Overview && <SectionProductGallery data={Overview} />,
        Specification && <app-dynamic-section __component='sections.product-details' data={Specification} />,
    ]
};